// Wraps the /portal/* route tree. If not signed in, renders the sign-in
// stub (magic-link only — customers can't sign up themselves).
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { usePortal } from "@/state/portal";

export function PortalGate({ children }: { children: ReactNode }) {
  const { me } = usePortal();
  if (me === undefined) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <div className="animate-pulse text-lg text-muted-foreground">Portal…</div>
      </div>
    );
  }
  if (me === null) return <PortalSignedOut />;
  return <>{children}</>;
}

function PortalSignedOut() {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-card p-8 text-center shadow-lg">
        <h1 className="font-display text-2xl font-semibold tracking-tight">Portal sign-in</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          You need a magic link from your account team to sign in.
          Links expire 15 minutes after they're issued.
        </p>
        <p className="mt-4 text-xs text-muted-foreground">
          Already have a link? <Link to="/portal" className="text-primary underline">Refresh</Link> after opening it.
        </p>
      </div>
    </div>
  );
}
